<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Maturing Leas list</h4>
          </div>
          <div class="col-6 text-right"></div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0">From</label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="fromDate"
            ></datePicker>
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0">To</label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="toDate"
            ></datePicker>
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="1">Contacted</option>
              <option value="2">Converted</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnExport()">
              Export
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('id')">Quote Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('dealer')"
                    >Original Referrer</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'dealer'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'dealer'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('client')"
                    >Client Name</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'client'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'client'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Email</th>
                <th class="header-item">Make</th>
                <th class="header-item">Model</th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('settlementDate')"
                    >Date Settled</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'settlementDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'settlementDate'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('maturingDate')"
                    >Date Maturing</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'maturingDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'maturingDate'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('created_at')"
                    >Created</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'created_at'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'created_at'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('sortOrder')"
                    >Status</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'sortOrder'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'sortOrder'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(quote, index) in getMaturingLeasPaginateData.data"
              >
                <tr :key="(quote, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td>{{ quote.id }}</td>
                  <td>{{ quote.dealer }}</td>
                  <td>{{ quote.client }}</td>
                  <td>
                    {{ quote.clientEmail }} <br />
                    {{ quote.clientMobileNumber }}
                  </td>
                  <td>{{ quote.make }}</td>
                  <td>{{ quote.model }}</td>
                  <td>
                    {{ quote.settlementDate | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ quote.maturingDate | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ quote.created_at | dateConvertDDMMYYYY }}
                  </td>
                  <td class="v-td-center">
                    <WDMaturingStatusBadge
                      v-if="quote.get_maturing_leas"
                      :status="quote.get_maturing_leas.status"
                    ></WDMaturingStatusBadge>
                  </td>
                  <td class="v-td-center">
                    <div class="d-flex">
                      <a
                        @click="fnGoViewQuote(quote.id)"
                        v-b-tooltip.hover
                        title="View old quote"
                        class="d-inline pr-2"
                        ><i class="far fa-eye text-primary fs-1000"></i
                      ></a>
                      <appModalNoteAdd
                        :quoteId="quote.id"
                        class="d-inline pr-2"
                      ></appModalNoteAdd>
                      <div>
                        <span
                          v-if="
                            quote.get_maturing_leas &&
                            quote.get_maturing_leas.status == 2
                          "
                        >
                          <i class="las la-hand-paper fs-1200"></i
                        ></span>
                        <span v-else>
                          <appModalCreateNewQuote
                            :propsData="quote"
                            class="d-inline"
                          ></appModalCreateNewQuote
                        ></span>
                      </div>
                    </div>
                  </td>
                </tr>

                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="13">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-6 col-md-6 col-12">
                        <!-- VSA quotes and leads logs -->
                        <WDVsaQuoteLeadsLogs
                          v-if="quote.vsa_logs.length"
                          :vsaLogs="quote.vsa_logs"
                        ></WDVsaQuoteLeadsLogs>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <!-- Maturing leas notes and information -->
                        <WDMaturingLeasInfo
                          v-if="quote.get_maturing_leas"
                          :details="quote.get_maturing_leas.details"
                        ></WDMaturingLeasInfo>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="13">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getMaturingLeasPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as authService from '../../../services/auth.service'
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'
import store from '../../../store/modules/base.module'
import * as taxTableService from '../../../services/taxTable.service'
import * as maturingLeasService from '../../../services/maturingLeas.service'
import appModalNoteAdd from '../../../components/admin/maturingLeases/ModalNoteAdd.vue'
import WDVsaQuoteLeadsLogs from '../../../components/wd/WDVsaQuoteLeadsLogs.vue'
import WDMaturingLeasInfo from '../../../components/wd/WDMaturingLeasInfo.vue'
import WDMaturingStatusBadge from '../../../components/wd/WDMaturingStatusBadge.vue'
import appModalCreateNewQuote from '../../../components/admin/maturingLeases/ModalCreateNewQuote.vue'
import datePicker from 'vue2-datepicker'

export default {
  name: 'adminQuoteList',
  props: ['quoteType'],
  components: {
    pagination,
    WDVsaQuoteLeadsLogs,
    datePicker,
    appModalNoteAdd,
    WDMaturingLeasInfo,
    WDMaturingStatusBadge,
    appModalCreateNewQuote
  },
  data() {
    return {
      isDataFetch: true,
      loginUserObj: {},
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'maturingDate',
      quoteCalculation: {},
      fromDate: '',
      toDate: '',
      paginate: {
        fromDate: '',
        toDate: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'maturingDate'
      }
    }
  },
  computed: {
    ...mapGetters(['getMaturingLeasPaginateData', 'getMaturingLeasPaginate'])
  },
  methods: {
    ...mapActions(['fetchMaturingLeasPaginate']),
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    fnGoViewQuote(id) {
      if (this.loginUserObj.role_id == 1 || this.loginUserObj.role_id == 2) {
        this.$router.push({
          name: 'admin.maturingQuoteView',
          params: { quoteId: id }
        })
      }

      if (this.loginUserObj.role_id == 3) {
        this.$router.push({
          name: 'bdm.maturingQuoteView',
          params: { quoteId: id }
        })
      }
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchMaturingLeasPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchMaturingLeasPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchMaturingLeasPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'desc' ? 'asc' : 'desc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchMaturingLeasPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      this.fromDate = ''
      this.toDate = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        fromDate: '',
        toDate: '',
        sort_direction: 'desc',
        sort_field: 'maturingDate'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchMaturingLeasPaginate(objNew)
    },

    /**
     * Export Maturing Leas List into excel file and download
     */
    fnExport: async function () {
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }

      let objNew = { ...obj2 }

      const filePath = await maturingLeasService.createListExport(objNew)

      //file name and path of the finance doc.
      let obj3 = {
        file_name: filePath.data
      }

      // Download from Export Maturing Leas List in temp folder
      window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

      // Delete Export Maturing Leas List in temp folder
      await maturingLeasService.deleteListExport(obj3)
    }
  },
  created() {
    this.loginUserObj = authService.getUserFromToken()
    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      fromDate: '',
      toDate: '',
      sort_direction: 'desc',
      sort_field: 'maturingDate'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchMaturingLeasPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }
  .dealer-user-box {
    width: 300px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
<style scoped>
.multiselect {
  height: 35px !important;
  min-height: 35px !important;
}

.multiselect /deep/ .multiselect__tags {
  height: 35px !important;
  min-height: 35px !important;
  display: block;
  padding: 3px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}

.multiselect /deep/ .multiselect__select {
  height: 35px;
}
</style>
